import { DataGrid, GridCellParams, GridColDef, GridToolbar, GridToolbarExport } from '@mui/x-data-grid';
import { Box, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const Tables = ({
  list,
  columns,
  navigateUrl = '',
  csvName = '',
  isToolbar = true,
  getRowId,
  onRowSelect,
}: {
  list: any[];
  columns: GridColDef[];
  navigateUrl?: string;
  csvName?: string;
  isToolbar?: boolean;
  getRowId?: (row: any) => string;
  onRowSelect?: (row: any) => void;
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleCellClick = (aValue: GridCellParams) => {
    // 행 선택 콜백 호출
    if (onRowSelect) {
      onRowSelect(aValue.row);
    }

    // 기존 네비게이션 로직
    if (navigateUrl) {
      navigate(navigateUrl, {
        state: {
          rowValue: aValue.row,
        },
      });
    }
  };
  return (
    <Box
      sx={{
        width: '100%',
        '& .MuiDataGrid-root': {
          borderRadius: '10px',
          overflow: 'hidden', // To ensure the border-radius is applied correctly
        },
        '& .MuiDataGrid-main': {
          borderRadius: '10px', // Outer border radius
        },
        '& .MuiDataGrid-columnHeaders': {
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        },
        '& .MuiDataGrid-virtualScroller': {
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          paddingRight: '5px',
        },
      }}
    >
      <DataGrid
        autoHeight
        sx={{
          border: 'none',
          boxShadow: '0px 0px 4px 0px #00000026',
          '& .MuiDataGrid-columnHeader': {
            height: '46px !important',
            background: theme.brand.primary,
            color: '#ffffff',
            typography: 'subtitle2',
          },
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:selected': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },

          '& .MuiDataGrid-cell': {
            outline: 'none',
            typography: 'body2',
            color: theme.greyscale.grey3,
            display: 'flex',
            alignItems: 'center',
          },
        }}
        hideFooter
        rows={list}
        columns={columns}
        getRowId={getRowId || ((row: any) => String(row.index || row.id || row.name || Math.random()))}
        onCellClick={handleCellClick}
        components={{
          Toolbar: isToolbar
            ? () => (
                <div>
                  <GridToolbar />
                  <GridToolbarExport
                    csvOptions={{
                      fileName: csvName,
                      utf8WithBom: true,
                    }}
                  />
                </div>
              )
            : undefined, // Toolbar를 비활성화
        }}
      />
    </Box>
  );
};
